import React from "react"
import { useRef, useEffect } from "react"
import Section from "./section"

const MLiveBlog = (props) => {
  const tickaroo_liveblog_id = props.data.video_embed_id
  const tickaroo_client_id = "6328afe61ec2ed8431d9e5e9"

  const ref = useRef(null)

  const loadAndInject = ({ scriptUrl, targetElement, callback }) => {
    const script = document.createElement("script")
    script.src = scriptUrl
    script.async = true
    script.onload = callback

    targetElement.appendChild(script)
  }

  const initializeLiveblog = () => {
    const liveblogTargetElement = ref.current
    window._tik("embedLiveblog", {
      container: liveblogTargetElement,
      clientId: tickaroo_client_id,
      id: tickaroo_liveblog_id,
    })
  }

  useEffect(() => {
    if (typeof window._tik === "undefined") {
      const liveblogTargetElement = ref.current
      loadAndInject({
        scriptUrl: "//cdn.tickaroo.com/embedjs/tik3.js",
        targetElement: liveblogTargetElement,
        callback: initializeLiveblog,
      })
    } else {
      initializeLiveblog()
    }
  }, [])

  return (
    <Section baseClass="m-Liveblog" defaultPadding="medium" data={props.data}>
      <div className="m-Liveblog-wrapper">
        <div className="m-Liveblog-container">
          <div
            ref={ref}
            className="m-Liveblog-target"
            data-tickaroo-liveblog-id={tickaroo_liveblog_id}
            data-tickaroo-client-id={tickaroo_client_id}
          ></div>
        </div>
      </div>
    </Section>
  )
}
export default MLiveBlog
